import { connect } from 'react-redux';
import SwitcherList from './SwitcherList';
import { getAllQuickSubscriptions } from 'reducers';
import { fetchAll as fetchSubs } from 'subscriptions/quick/actions';

const mapStateToProps = (state) => ({
  subs: getAllQuickSubscriptions(state),
});

const mapDispatchToProps = {
  fetchSubs
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitcherList);

